import { ExternalLink } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function LocationMap() {
  return <section data-section-id="256986" id="location-map" className="bg-background py-16 md:py-24 text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-[var(--max-content-width)]">
        
        {}
        <div className="text-center mb-10 max-w-3xl mx-auto flex flex-col gap-4">
          <h2 className="text-3xl md:text-5xl font-bold font-default text-primary">
            Serving New Jersey & Pennsylvania
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-sans">
            Our dedicated team provides rapid response times across the entire tri-state border region, ensuring professional support is always nearby.
          </p>
        </div>

        {}
        <div className="relative w-full h-[400px] sm:h-[500px] lg:h-[600px] bg-muted rounded-lg overflow-hidden shadow-medium border border-border">
          
          {}
          <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d387193.305935303!2d-74.25986548248684!3d40.69714941932609!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1710365000000!5m2!1sen!2sus" className="absolute inset-0 w-full h-full border-0 grayscale-[20%] contrast-[1.1]" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Service Area Map"></iframe>

          {}
          <div className="absolute top-4 left-4 z-10">
            <Button variant="outline" size="sm" className="bg-background/90 backdrop-blur-md shadow-soft hover:bg-accent text-foreground font-default border-border" asChild>
              <Link to="https://maps.google.com" newTab>
                View Full Map <ExternalLink className="ml-2 size-3.5" />
              </Link>
            </Button>
          </div>

          {}
        </div>

      </div>
    </section>;
}